import React from 'react';
import { ServicesContext } from './ServicesProvider';

var useServicesContext = function useServicesContext() {
  return React.useContext(ServicesContext);
};

export default useServicesContext;